import styled from 'styled-components';

const fontSize = ['2.1rem', '1.9rem', '1.5rem', '1.25rem', '1.125rem'];
const letterSpacing = ['-1.5px', '-1px', '0px', '0.25px', '0px'];

interface HeaderProps {
  /** How big should the header be? */
  level: number;
}

export const StyledHeader = styled.p<HeaderProps>`
  color: ${({ theme }) => theme.fontColour};

  font-family: 'Montserrat';
  font-size: ${({ level }) => fontSize[level - 1]};

  letter-spacing: ${({ level }) => letterSpacing[level - 1]};

  margin: 0.2em 0 0.5em;
`;
StyledHeader.defaultProps = {
  theme: {
    fontColour: '#232323',
  },
};
